import React from "react";
import {useAppSelector,rootActions, useAppDispatch} from "../../DAL/store";
import SearchIcon from "../../../../ui/svg/common/search";
import {PluginsSortOptions} from "./plugins-sort-options";
import {AddToCart, SetIsAnnual} from "../../services/logic-helper";
import {Price} from "../price";
import { PriceDifferent } from "../price-different";
import {ToggleStyled} from "../../../../ui/toggle/toggle-styled";

export const PlansPopup = () => {

    const PageData = useAppSelector((store) => store.PageData);
    const SearchFilterKey = useAppSelector((store) => store.SearchFilterKey);

    const IsAnnual = useAppSelector((store) => store.IsAnnual);
    const IsPriceDifferent = useAppSelector((store) => store.IsPriceDifferent);

    const dispatch = useAppDispatch();

    const StarterPlan = IsAnnual ?
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("low"))[0] :
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("low"))[0];
    const PremiumPlan = IsAnnual ?
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("high"))[0] :
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("high"))[0];

    //if StarterPlan.numberOfFreeDays > 0 --> button's text :  Start Free 7-Day Trial
    //else --> button's text :  Get Access
    const StarterButtonText = StarterPlan.numberOfFreeDays > 0 ? "Start Free "+StarterPlan.numberOfFreeDays+"-day Trial" : "Subscribe Now";
    const PremiumButtonText = PremiumPlan.numberOfFreeDays > 0 ? "Start Free "+PremiumPlan.numberOfFreeDays+"-day Trial" : "Subscribe Now";

    return (
          <div className="flex items-center pt-4" >
              <div className="w-full flex items-center bg-dark-blue text-white px-4">
                  <div className="relative flex-1 mb-2" style={{height:"350px"}}>
                      <div className="w-full pt-3 pl-2 text-2xl"  style={{height:"170px"}}>Compare Plans</div>

                      <div className="flex items-center  text-lg py-2" style={{height: "75px"}}>
                          <div className={`${!IsAnnual ? "font-bold" : ""}`}>Monthly</div>
                          <div className="mx-2 toggle-switch-popup">
                              <ToggleStyled
                                  padding={4}
                                  handleColor={"#EFFF00"}
                                  width={57}
                                  height={29}
                                  isToogle={IsAnnual}
                                  adaText= {IsAnnual ? 'Annually plan selected' : 'Monthly plan selected'}
                                  onClick={(isToogle: boolean) => SetIsAnnual(isToogle, dispatch)}

                                  textStyles={{
                                      margiLeft: '-5px'
                                  }}
                              />
                          </div>
                          <div className={`${IsAnnual ? "font-bold" : ""}`}>Annual</div>
                      </div>
                      <div
                          className="search-plugins-input-container w-full overflow-hidden py-1 outline-none bg-dark-input rounded-full flex items-center"
                          style={{marginTop:"35px"}}>
                          <SearchIcon classes={"ml-4 mr-2"} width={"15px"} color={"white"} />

                          <input
                              className="flex-1 text-sm font-normal text-white bg-dark-input outline-none"
                              aria-label={ "filterPlaceholderText" }
                              value={ SearchFilterKey }
                              autoComplete="off"
                              type="text"
                              placeholder={ "Search plugins" }
                              onChange={ evt => {
                                  dispatch(
                                      rootActions.main({
                                          SearchFilterKey:evt.target.value.trim()
                                      })
                                  )
                              }}
                              style={{
                                  textIndent: '10px'
                              }}
                          ></input>
                      </div>

                     <PluginsSortOptions />
                  </div>


                  <div className="w-full flex items-center justify-center mt-6 mb-6 text-center"  style={{width:"690px"}}>
                      <div className="w-full bg-fade-down-blue-popup rounded-xl pb-12" style={{width:"335px",marginRight:"20px",height:"351px"}}>
                          <div className="w-full text-2xl mt-8 font-bold pt-6 font-montserrat">{StarterPlan.tierName}</div>
                          <div className="w-full text-tiny mt-4 px-8 h-10"><span dangerouslySetInnerHTML={{ __html: StarterPlan.tagline }} /></div>
                          <div className="w-full text-4xl font-bold mt-4">
                              {!IsPriceDifferent && <Price plan={StarterPlan} isStarter={true}  isPopup={true} caller="PlansPopup"/>}
                              {IsPriceDifferent && <PriceDifferent plan={StarterPlan} isStarter={true}  isPopup={true}/>}

{/*
                              <span><ProductPriceFormat price={ StarterPlan.skU_MSRP } /><span className="text-base font-normal"> / {IsAnnual ? "year":"month"}</span></span>
*/}
                          </div>

                          <div className="w-full mt-3 py-1 flex items-center justify-center">
                              <button
                                  type="button"
                                  onClick={() => AddToCart(StarterPlan)}  className="text-white no-underline font-medium bg-mid-purple px-8 py-3 rounded-full text-base text-lg w-fit cursor-pointer">{StarterButtonText}</button>
                          </div>
                      </div>
                      <div className={`w-full bg-fade-down-purple-popup rounded-xl relative pb-12`} style={{width:"335px",height:"351px"}} >

                          <div
                              className="badge-popular w-auto text-white text-tiny md:text-xl py-2 md:py-3 px-4 md:px-8 rounded-full absolute-center top-0">
                              Popular
                          </div>

                          <div
                              className="w-full text-2xl mt-8 font-bold pt-6 font-montserrat">{PremiumPlan.tierName}</div>
                          <div className="w-full text-tiny mt-4 px-8 h-10"><span dangerouslySetInnerHTML={{ __html: PremiumPlan.tagline }} /></div>
                          <div className="w-full text-4xl font-bold mt-4">
                              {!IsPriceDifferent && <Price plan={PremiumPlan} isStarter={false} isPopup={true} caller="PlansPopup"/>}
                              {IsPriceDifferent && <PriceDifferent plan={PremiumPlan} isStarter={false} isPopup={true} />}
{/*
                              <span><ProductPriceFormat price={ PremiumPlan.skU_MSRP } /><span className="text-base font-normal"> / {IsAnnual ? "year":"month"}</span></span>
*/}
                          </div>

                          <div className="w-full mt-3 py-1 flex items-center justify-center">
                              <button type={"button"} onClick={() => AddToCart(PremiumPlan)}  className="text-black no-underline font-medium bg-yellow  px-8 py-3 rounded-full text-base text-lg w-fit cursor-pointer">{PremiumButtonText}</button>
                          </div>

                      </div>

                  </div>
              </div>

          </div>
    )
};